import { createFileRoute } from "@tanstack/react-router"

import { SoftReceivedPurchaseOrdersTab } from "@/screens/WarehouseReceiving/subfeatures/SoftReceived/components"

export const Route = createFileRoute(
  "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders"
)({
  component: SoftReceivedPurchaseOrdersTab,
})
